<template>
  <v-container>
    <h2 class="text-center">Page not found</h2>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer"
    ></v-img>   
  </v-container>
</template>

<script>
export default {
  data: () => ({
    packShot : {src:require('../assets/Packshots.png')}
  }),
};
</script>
